/**
 * @generated SignedSource<<0de7a356754611ad3c107a7c0da98c17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getAggregatedOrderFinancialSummary_order$data = {
  readonly lineItemGroups: ReadonlyArray<{
    readonly lineItems: ReadonlyArray<{
      readonly appliedDiscounts?: ReadonlyArray<{
        readonly amountCents: number | null | undefined;
        readonly squareExternalDiscountId: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly orderDiscounts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly amount: number | null | undefined;
        readonly appliedAmount: number | null | undefined;
        readonly squareExternalId: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly serviceCharges: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly amount: number;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly total: number | null | undefined;
  readonly totalDiscount: number | null | undefined;
  readonly totalTaxes: number | null | undefined;
  readonly " $fragmentType": "getAggregatedOrderFinancialSummary_order";
};
export type getAggregatedOrderFinancialSummary_order$key = {
  readonly " $data"?: getAggregatedOrderFinancialSummary_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"getAggregatedOrderFinancialSummary_order">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getAggregatedOrderFinancialSummary_order"
};

(node as any).hash = "70a09c8c6f4d1a733f4388ea84ba2a6a";

export default node;
